import type * as Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Sets isEditable to true for AssetGroups that have color or alpha graphics
 */
function setIsEditableForAssetGroup(
    map: Immutable.Map<string, unknown>,
    path: Array<string | number>,
) {
    const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
    if (!asset) {
        return;
    }

    const classType = asset.get('classType');
    if (classType !== 'AssetGroup') {
        return;
    }

    const colorGraphics = asset.get('colorGraphics') as Immutable.List<unknown> | undefined;
    const alphaGraphics = asset.get('alphaGraphics') as Immutable.List<unknown> | undefined;

    if (
        (!colorGraphics || colorGraphics.size === 0) &&
        (!alphaGraphics || alphaGraphics.size === 0)
    ) {
        return;
    }

    map.setIn([...path, 'isEditable'], true);
}

export const migrationTo9_230 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            const children = map.get('children') as Immutable.List<unknown> | undefined;
            if (children) {
                children.forEach((_child: unknown, cIndex: number) => {
                    setIsEditableForAssetGroup(map, ['children', cIndex]);
                });
            }

            const subslides = map.get('subslides') as Immutable.List<unknown> | undefined;
            if (subslides) {
                subslides.forEach((_subslide: unknown, sIndex: number) => {
                    const subslide = map.getIn(['subslides', sIndex]) as
                        | Immutable.Map<string, unknown>
                        | undefined;
                    if (!subslide) {
                        return;
                    }

                    const subslideChildren = subslide.get('children') as
                        | Immutable.List<unknown>
                        | undefined;
                    if (subslideChildren) {
                        subslideChildren.forEach((_child: unknown, cIndex: number) => {
                            setIsEditableForAssetGroup(map, [
                                'subslides',
                                sIndex,
                                'children',
                                cIndex,
                            ]);
                        });
                    }
                });
            }
        });
    },
});
